

export const setRem = () => {
  const designWidth = 780 // 设计稿宽度
  const baseFontSize = 100 // 基准font-size，1rem = 100px
  const clientWidth = window.visualViewport?.width || document.documentElement.clientWidth || window.innerWidth
  // 仅按“手机宽度”做适配：超过该宽度后只拉宽容器，字号/高度/间距保持不变
  // 设计稿 780 通常对应 2x 逻辑像素，因此手机上限取 780/2 = 390
  const maxAdaptWidth = designWidth / 2
  const effectiveWidth = Math.min(clientWidth, maxAdaptWidth)
  
  // 计算实际font-size
  const fontSize = (effectiveWidth / designWidth) * baseFontSize
  
  // 限制最大和最小font-size
  const minFontSize = 50
  const maxFontSize = (maxAdaptWidth / designWidth) * baseFontSize
  const finalFontSize = Math.max(minFontSize, Math.min(maxFontSize, fontSize))
  
  document.documentElement.style.fontSize = `${finalFontSize}px`
}

// 判断当前环境是否是线上环境
export const isProd = () => {
  // 线下的路由是osm.51ping.com，线上的是osm.dianping.com
  return window.location.hostname.includes('osm.dianping.com')
}


